import { render } from "./tarkpay-bulk-payment-redirect.vue?vue&type=template&id=674045ed&scoped=true&ts=true"
import script from "./tarkpay-bulk-payment-redirect.vue?vue&type=script&lang=ts"
export * from "./tarkpay-bulk-payment-redirect.vue?vue&type=script&lang=ts"

import "./tarkpay-bulk-payment-redirect.vue?vue&type=style&index=0&id=674045ed&lang=scss&scoped=true"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674045ed"]])

export default __exports__